<ion-content>
  <div class="ion-padding heading-login">
    <ion-img src="assets/images/logos/gospread.png" class="brand" />
    <h1 class="title">Create Account</h1>
    <p>Join the GoSpread community</p>
  </div>
  <ion-tabs>
    <!-- Tab bar -->
    <ion-tab-bar color="secondary">
      <ion-tab-button *ngIf="showCaller" (click)="userSelect = userType.Caller"
        [ngClass]="{'selected': userSelect === userType.Caller}">Spreader</ion-tab-button>
      <ion-tab-button *ngIf="!paramRecomendation && showDriver" (click)="userSelect = userType.Driver"
        [ngClass]="{'selected': userSelect === userType.Driver}">Driver</ion-tab-button>
    </ion-tab-bar>
  </ion-tabs>
  <div class="form-container">
    <!-- Form Caller -->
    <form class="ion-padding container-form" [ngClass]="{'selected': userSelect === userType.Caller}"
      [formGroup]="formCaller">
      <h3 class="title-form">
        <ion-img src="assets/images/megafone.png" class="ico" /> Spreader Sign up
        Form
      </h3>

      <ion-item>
        <ion-label position="floating">First Name</ion-label>
        <ion-input formControlName="nome" type="text"></ion-input>
      </ion-item>
      <app-field-validator [fieldControl]="formCaller.get('nome')"></app-field-validator>

      <ion-item>
        <ion-label position="floating">Last Name</ion-label>
        <ion-input formControlName="sobrenome" type="text"></ion-input>
      </ion-item>
      <app-field-validator [fieldControl]="formCaller.get('sobrenome')"></app-field-validator>

      <ion-item>
        <ion-label position="floating">Email</ion-label>
        <ion-input formControlName="email" type="email"></ion-input>
      </ion-item>
      <app-field-validator [fieldControl]="formCaller.get('email')"></app-field-validator>

      <ion-item>
        <ion-label position="floating">Cell Phone</ion-label>
        <ion-input formControlName="celular" type="tel"></ion-input>
      </ion-item>
      <app-field-validator [fieldControl]="formCaller.get('celular')"></app-field-validator>

      <ion-item>
        <ion-label position="floating">Work Place</ion-label>
        <ion-input formControlName="nomeEstabelecimento" type="text"></ion-input>
      </ion-item>
      <app-field-validator [fieldControl]="formCaller.get('nomeEstabelecimento')"></app-field-validator>

      <ion-item>
        <ion-label position="floating">Position</ion-label>
        <ion-input formControlName="position" type="text"></ion-input>
      </ion-item>
      <app-field-validator [fieldControl]="formCaller.controls['position']"></app-field-validator>

      <ion-item>
        <ion-label position="floating">Work Address</ion-label>
        <ion-input formControlName="enderecoEstabelecimento" type="text"></ion-input>
      </ion-item>
      <app-field-validator [fieldControl]="formCaller.controls['enderecoEstabelecimento']"></app-field-validator>

      <ion-item>
        <ion-label position="floating">City</ion-label>
        <ion-input formControlName="cidadeEstabelecimento" type="text"></ion-input>
      </ion-item>
      <app-field-validator [fieldControl]="formCaller.get('cidadeEstabelecimento')"></app-field-validator>

      <ion-item>
        <ion-label position="floating">State</ion-label>
        <ion-select value="" formControlName="state">
          <ion-select-option value="" disabled="disabled">Select the State</ion-select-option>
          <ion-select-option value="Alabama">Alabama (AL)</ion-select-option>
          <ion-select-option value="Alaska">Alaska (AK)</ion-select-option>
          <ion-select-option value="Arizona">Arizona (AZ)</ion-select-option>
          <ion-select-option value="AArkansasR">Arkansas (AR)</ion-select-option>
          <ion-select-option value="California">California (CA)</ion-select-option>
          <ion-select-option value="Colorado">Colorado (CO)</ion-select-option>
          <ion-select-option value="Connecticut">Connecticut (CT)</ion-select-option>
          <ion-select-option value="Delaware">Delaware (DE)</ion-select-option>
          <ion-select-option value="District of Columbia">District of Columbia (DC)</ion-select-option>
          <ion-select-option value="Florida">Florida (FL)</ion-select-option>
          <ion-select-option value="Georgia">Georgia (GA)</ion-select-option>
          <ion-select-option value="Hawaii">Hawaii (HI)</ion-select-option>
          <ion-select-option value="Idaho">Idaho (ID)</ion-select-option>
          <ion-select-option value="Illinois">Illinois (IL)</ion-select-option>
          <ion-select-option value="Indiana">Indiana (IN)</ion-select-option>
          <ion-select-option value="Iowa">Iowa (IA)</ion-select-option>
          <ion-select-option value="Kansas">Kansas (KS)</ion-select-option>
          <ion-select-option value="Kentucky">Kentucky (KY)</ion-select-option>
          <ion-select-option value="Louisiana">Louisiana (LA)</ion-select-option>
          <ion-select-option value="Maine">Maine (ME)</ion-select-option>
          <ion-select-option value="Maryland">Maryland (MD)</ion-select-option>
          <ion-select-option value="Massachusetts">Massachusetts (MA)</ion-select-option>
          <ion-select-option value="Michigan">Michigan (MI)</ion-select-option>
          <ion-select-option value="Minnesota">Minnesota (MN)</ion-select-option>
          <ion-select-option value="Mississippi">Mississippi (MS)</ion-select-option>
          <ion-select-option value="Missouri">Missouri (MO)</ion-select-option>
          <ion-select-option value="Montana">Montana (MT)</ion-select-option>
          <ion-select-option value="Nebraska">Nebraska (NE)</ion-select-option>
          <ion-select-option value="Nevada">Nevada (NV)</ion-select-option>
          <ion-select-option value="New Hampshire">New Hampshire (NH)</ion-select-option>
          <ion-select-option value="New Jersey">New Jersey (NJ)</ion-select-option>
          <ion-select-option value="New Mexico">New Mexico (NM)</ion-select-option>
          <ion-select-option value="New York">New York (NY)</ion-select-option>
          <ion-select-option value="North Carolina">North Carolina (NC)</ion-select-option>
          <ion-select-option value="North Dakota">North Dakota (ND)</ion-select-option>
          <ion-select-option value="Ohio">Ohio (OH)</ion-select-option>
          <ion-select-option value="Oklahoma">Oklahoma (OK)</ion-select-option>
          <ion-select-option value="Oregon">Oregon (OR)</ion-select-option>
          <ion-select-option value="Pennsylvania">Pennsylvania (PA)</ion-select-option>
          <ion-select-option value="Rhode Island">Rhode Island (RI)</ion-select-option>
          <ion-select-option value="South Carolina">South Carolina (SC)</ion-select-option>
          <ion-select-option value="South Dakota">South Dakota (SD)</ion-select-option>
          <ion-select-option value="Tennessee">Tennessee (TN)</ion-select-option>
          <ion-select-option value="Texas">Texas (TX)</ion-select-option>
          <ion-select-option value="Utah">Utah (UT)</ion-select-option>
          <ion-select-option value="Vermont">Vermont (VT)</ion-select-option>
          <ion-select-option value="Virginia">Virginia (VA)</ion-select-option>
          <ion-select-option value="Washington">Washington (WA)</ion-select-option>
          <ion-select-option value="West Virginia">West Virginia (WI)</ion-select-option>
          <ion-select-option value="Wisconsin">Wisconsin (WV)</ion-select-option>
          <ion-select-option value="Wyoming">Wyoming (WY)</ion-select-option>
        </ion-select>
      </ion-item>
      <app-field-validator [fieldControl]="formCaller.get('state')"></app-field-validator>

      <ion-item>
        <ion-label position="floating">Zip Code</ion-label>
        <ion-input formControlName="zipCode" type="number"></ion-input>
      </ion-item>
      <app-field-validator [fieldControl]="formCaller.get('zipCode')"></app-field-validator>

      <ion-item>
        <ion-label position="floating">Phone</ion-label>
        <ion-input formControlName="telefoneEstabelecimento" type="tel"></ion-input>
      </ion-item>
      <app-field-validator [fieldControl]="formCaller.get('telefoneEstabelecimento')"></app-field-validator>

      <ion-item>
        <ion-label position="floating">Password</ion-label>
        <ion-input formControlName="senha" [type]="visiblePassword ? 'text': 'password'"></ion-input>
        <button class="eye-bt" (click)="visiblePassword = !visiblePassword" ion-button clear type="button" item-right>
          <ion-icon [name]="visiblePassword ? 'eye-off': 'eye'"> </ion-icon>
        </button>
      </ion-item>
      <app-field-validator [fieldControl]="formCaller.controls['senha']"></app-field-validator>

      <ion-item>
        <ion-label position="floating">Confirm Password</ion-label>
        <ion-input formControlName="confirmarsenha" type="password"></ion-input>
      </ion-item>
      <app-field-validator [fieldControl]="formCaller.get('confirmarsenha')"></app-field-validator>

      <div class="input-light check-item">
        <ion-checkbox id="accept" formControlName="termos"></ion-checkbox>
        <label for="accept">I have read, understand and agree to the <br />
          <a (click)="openTerms()">GoSpread’s Terms and Conditions.</a></label>
      </div>

      <ion-button class="ion-margin-top" [disabled]="formCaller.invalid" color="primary" expand="full" shape="round"
        (click)="registerUser(userType.Caller)">Register</ion-button>
    </form>

    <!-- Form Driver -->
    <form [formGroup]="formDriver" class="ion-padding container-form"
      [ngClass]="{'selected': userSelect === userType.Driver}">
      <h3 class="title-form">
        <ion-img src="assets/images/avatar-motorista-volante.png" class="ico" />
        Driver Sign up Form
      </h3>

      <ion-item>
        <ion-label position="floating">First Name</ion-label>
        <ion-input formControlName="nome" type="text"></ion-input>
      </ion-item>
      <app-field-validator [fieldControl]="formDriver.get('nome')"></app-field-validator>

      <ion-item>
        <ion-label position="floating">Last Name</ion-label>
        <ion-input formControlName="sobrenome" type="text"></ion-input>
      </ion-item>
      <app-field-validator [fieldControl]="formDriver.get('sobrenome')"></app-field-validator>

      <ion-item>
        <ion-label position="floating">Email</ion-label>
        <ion-input formControlName="email" type="email"></ion-input>
      </ion-item>
      <app-field-validator [fieldControl]="formDriver.get('email')"></app-field-validator>

      <ion-item>
        <ion-label position="floating">Cell Phone</ion-label>
        <ion-input formControlName="celular" type="tel"></ion-input>
      </ion-item>
      <app-field-validator [fieldControl]="formDriver.get('celular')"></app-field-validator>

      <ion-item>
        <ion-label position="floating">Driver’s License</ion-label>
        <ion-input formControlName="documento" type="text"></ion-input>
      </ion-item>
      <app-field-validator [fieldControl]="formDriver.get('documento')"></app-field-validator>

      <ion-item>
        <ion-label position="floating">Other Languages</ion-label>
        <ion-select multiple formControlName="idiomas">
          <ion-select-option *ngFor="let language of languagesUser" [value]="language.value"
            [disabled]="checkValue(language)">
            {{ language.label }}
          </ion-select-option>
        </ion-select>
      </ion-item>
      <app-field-validator [fieldControl]="formDriver.get('idiomas')"></app-field-validator>

      <ion-item>
        <ion-label position="floating">Password</ion-label>
        <ion-input formControlName="senha" [type]="visiblePassword ? 'text': 'password'"></ion-input>
        <button class="eye-bt" (click)="visiblePassword = !visiblePassword" ion-button clear type="button" item-right>
          <ion-icon [name]="visiblePassword ? 'eye-off': 'eye'"> </ion-icon>
        </button>
      </ion-item>
      <app-field-validator [fieldControl]="formDriver.get('senha')"></app-field-validator>

      <ion-item>
        <ion-label position="floating">Confirm Password</ion-label>
        <ion-input formControlName="confirmarsenha" type="password"></ion-input>
      </ion-item>
      <app-field-validator [fieldControl]="formDriver.get('confirmarsenha')"></app-field-validator>

      <div class="block" formGroupName="veiculo">
        <h3 class="title-form">
          <ion-img src="assets/automobile.svg" class="ico" />Vehicle information
        </h3>

        <ion-item>
          <ion-label position="floating">Make</ion-label>
          <ion-input formControlName="marca" type="text"></ion-input>
        </ion-item>
        <app-field-validator [fieldControl]="formDriver.get('veiculo.marca')"></app-field-validator>

        <ion-item>
          <ion-label position="floating">Model</ion-label>
          <ion-input formControlName="modelo" type="text"></ion-input>
        </ion-item>
        <app-field-validator [fieldControl]="formDriver.get('veiculo.modelo')"></app-field-validator>

        <ion-item>
          <ion-label position="floating">Year</ion-label>
          <ion-input value="{{ date | date: 'yyyy' }}" id="date" class="ion-text-end"></ion-input>
          <ion-popover size="cover" trigger="date">
            <ng-template>
              <ion-datetime [showDefaultButtons]="true" formControlName="ano" presentation="year" [preferWheel]="true"
                size="cover" (ionChange)="formatYear($event)"></ion-datetime>
            </ng-template>
          </ion-popover>

        </ion-item>
        <app-field-validator [fieldControl]="formDriver.get('veiculo.ano')"></app-field-validator>

        <ion-item>
          <ion-label position="floating">Car Color</ion-label>
          <ion-input formControlName="cor" type="text"></ion-input>
        </ion-item>
        <app-field-validator [fieldControl]="formDriver.get('veiculo.ano')"></app-field-validator>

        <ion-item>
          <ion-label position="floating">License plate</ion-label>
          <ion-input formControlName="placa" type="text"></ion-input>
        </ion-item>
        <app-field-validator [fieldControl]="formDriver.get('veiculo.placa')"></app-field-validator>

        <ion-item>
          <ion-label position="floating">Style</ion-label>
          <ion-select formControlName="tipoVeiculo">
            <ion-select-option [value]="type.value" *ngFor="let type of typesVehicle">
              {{ type.label }}
            </ion-select-option>
          </ion-select>
        </ion-item>
        <app-field-validator [fieldControl]="formDriver.get('veiculo.tipoVeiculo')"></app-field-validator>
      </div>

      <div class="input-light check-item">
        <ion-checkbox id="accept" formControlName="termos"></ion-checkbox>
        <label for="accept">I have read, understand and agree to the <br />
          <a (click)="openTerms()">GoSpread’s Terms and Conditions.</a></label>
      </div>

      <ion-button [disabled]="formDriver.invalid" class="ion-margin-top" color="primary" expand="full" shape="round"
        (click)="registerUser(userType.Driver)">Register</ion-button>
    </form>

    <div class="register-footer">
      <span>Already have an account?</span>
      <a routerLink="/login" class="register-footer__link">Sign In</a>
    </div>
  </div>
</ion-content>